module.exports = __webpack_public_path__ + "media/images/city-test-pic-6bca41a0bc873817e41c39151789360f.png";